export const ArrayToken = 'SLONIK_TOKEN_ARRAY' as const;
export const BinaryToken = 'SLONIK_TOKEN_BINARY' as const;
export const ComparisonPredicateToken =
  'SLONIK_TOKEN_COMPARISON_PREDICATE' as const;
export const DateToken = 'SLONIK_TOKEN_DATE' as const;
export const FragmentToken = 'SLONIK_TOKEN_FRAGMENT' as const;
export const IdentifierToken = 'SLONIK_TOKEN_IDENTIFIER' as const;
export const IntervalToken = 'SLONIK_TOKEN_INTERVAL' as const;
export const JsonBinaryToken = 'SLONIK_TOKEN_JSON_BINARY' as const;
export const JsonToken = 'SLONIK_TOKEN_JSON' as const;
export const ListToken = 'SLONIK_TOKEN_LIST' as const;
export const QueryToken = 'SLONIK_TOKEN_QUERY' as const;
export const TimestampToken = 'SLONIK_TOKEN_TIMESTAMP' as const;
export const UnnestToken = 'SLONIK_TOKEN_UNNEST' as const;
